import { Injectable, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { filter } from 'rxjs/operators';
import { Section } from '../models/sections.interface';
import { mainSection, settingsSection } from "../constants/sections.constant";
import { AppService } from './app.service';
import { TranslateService } from '@ngx-translate/core';
import { AppStateHolder } from '../shared/app-state.holder';
import { GoogleAnalyticsService } from './google-analytics.service';
import { SessionService } from './session.service';
import { DebugLoggerService } from './debug-logger.service';

import { Title } from '@angular/platform-browser';
import { map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _router = inject(Router);
  private _appSrv = inject(AppService);
  private _googleAnalyticsService = inject(GoogleAnalyticsService);
  private _ssnService = inject(SessionService);
  private location = inject(Location);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private titleService = inject(Title);
  translate = inject(TranslateService);
  private _debugLogger = inject(DebugLoggerService);

  activeRoute: any;
  showSidebar: boolean = false;

  private _backEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public backEnabled: Observable<boolean> = this._backEnabled.asObservable();

  private _actions: BehaviorSubject<Array<Section>> = new BehaviorSubject<Array<Section>>([]);
  public actions: Observable<Array<Section>> = this._actions.asObservable();
  private _isExpanded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isExpanded: Observable<boolean> = this._isExpanded.asObservable();
  private _toggleMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public toggleMobile: Observable<boolean> = this._toggleMobile.asObservable();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  public subscribeEventsNavigation(): any {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this._setActions(data.urlAfterRedirects);
        const title = data['title'] || 'Suite Azienda'; // Use 'AmSuite' if no title is configured
        this.titleService.setTitle(title);
      });
  }

  public goBack(): void {
    this._debugLogger.logNavigation('SidebarService', { action: 'goBack' });
    this.showSidebar = false;
    this.location.back();
  }

  public setExpand(expand: boolean): void {
    this._debugLogger.logState('SidebarService', 'expand', expand);
    this._appSrv.setMenuIsOpen(expand);
    this._isExpanded.next(expand);
  }

  public get getStateExpanded(): boolean {
    return this._isExpanded.getValue();
  }

  public setToggleMobile(toggle: boolean): void {
    this._debugLogger.logState('SidebarService', 'toggleMobile', toggle);
    this._toggleMobile.next(toggle);
  }

  private _setActions(url: string): void {
    this._debugLogger.logNavigation('SidebarService._setActions', { url });
    this.activeRoute = url;
    switch (url) {
      case "/accountSettings":
      case "/userInfo":
        this.showSidebar = true;
        this._backEnabled.next(true);
        this._actions.next(settingsSection);
        break;
      default:
        this.showSidebar = false;
        this._backEnabled.next(false);
        this._actions.next(mainSection);
        break;
    }
  }

}
